import type { CsvPreviewResult } from 'bundles/enterprise-admin-learners/hooks/useCsvInvitePipeline';

export type CsvGroupAssignmentDecision = {
  /** True when every row already carries a group, or the group is already known; skip the step, submit directly. */
  skipGroupStep: boolean;
};

type ResolveCsvGroupAssignmentArgs = {
  groupColumnState: CsvPreviewResult['groupColumnState'];
  /** Set when the group is already known (Group Details entry, or a single-group Group admin) — see getAutoSelectedGroupId. */
  autoSelectedGroupId: string | undefined;
};

/**
 * Skips the group-assignment step when the group is already known, or when any row already
 * carries a group (PARTIAL or ALL_ROWS) — the backend routes each row by its own group regardless.
 */
export const resolveCsvGroupAssignment = ({
  groupColumnState,
  autoSelectedGroupId,
}: ResolveCsvGroupAssignmentArgs): CsvGroupAssignmentDecision => ({
  skipGroupStep: Boolean(autoSelectedGroupId) || groupColumnState !== 'ABSENT',
});
